module.exports = __webpack_public_path__ + "static/media/top_18.85836cc6.svg";